import { z } from 'zod';

export const jnetRequestDataSchema = z.object({
    username: z.string().trim().min(1),
    firstName: z.string().trim().min(1),
    lastName: z.string().trim().min(1),
    ssn: z.string().trim().length(4),
    birthDate: z.string().trim().min(1),
    test: z
        .object({
            returnCode: z.number(),
        })
        .optional(),
});

export const jnetResponseSchema = z.object({
    result: z.boolean(),
    requestId: z.string().uuid(),
});

export const awsConfigSchema = z.object({
    awsRegion: z.string(),
    awsAccessKey: z.string(),
    awsSecretKey: z.string(),
});
